module.exports = __webpack_public_path__ + "static/media/ipad_pro_mockup_2.dc23c599.png";